module.exports = __webpack_public_path__ + "img/communication6.cebc2261.png";